import React, { useEffect } from 'react';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import './privacypolicy.css';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';

const Privacypolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-page">
      <NavBar />

      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="privacy-hero-content">
          <h1 className="privacy-hero-title">Privacy Policy</h1>
          <p className="privacy-hero-subtitle">
            Your privacy is important to us. This policy explains how we collect, use, and protect your personal information.
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="privacy-container">
        <section className="privacy-section">
          <h2 className="privacy-heading">Who We Are</h2>
          <p>
            Our website address is:{" "}
            <a href="https://www.easytaxexperts.com/">https://www.easytaxexperts.com/</a>
          </p>
          <p>
            Easy Tax Experts (“us”, “we”, or “our”) is a tax preparation and consulting service provider.
            This privacy policy explains how we collect, use, disclose, and protect your personal information when you use our services.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Information We Collect</h2>
          <p>We may collect personal information from you when you:</p>
          <ul>
            <li>Visit our website</li>
            <li>Contact us for services</li>
            <li>Engage with us on social media</li>
          </ul>
          <p>The information we collect may include:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, address, email, phone number, Social Security number,
              date of birth, financial details, and other identifiers.
            </li>
            <li>
              <strong>Device Information:</strong> Details about your computer, mobile device, IP address, browser type, and operating system.
            </li>
            <li>
              <strong>Usage Information:</strong> Information about how you use our services, including pages visited and links clicked.
            </li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">How We Use Information</h2>
          <p>
            Easy Tax Experts may also use your personal information to reach out to you about services we believe you may be interested in.
            We use this information to:
          </p>
          <ul>
            <li>Provide tax preparation and consulting services</li>
            <li>Communicate with you regarding your account and services</li>
            <li>Respond to your inquiries and requests</li>
            <li>Enhance our services and website</li>
            <li>Prevent fraud and abuse</li>
            <li>Comply with legal and regulatory requirements</li>
          </ul>
          <p>
            You will always have the option to opt out of receiving direct communications at any time.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Sharing Your Information</h2>
          <p>
            We will not share your mobile information with third parties or affiliates for marketing or promotional purposes.
            Other data, excluding text messaging opt-in information and consent, will not be shared with any third parties.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Data Security</h2>
          <p>
            We take reasonable steps to protect your personal information from unauthorized access, use, disclosure, alteration, or destruction.
            However, no method of transmission over the internet or electronic storage is completely secure.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Your Rights</h2>
          <ul>
            <li>Access and review your personal information</li>
            <li>Correct inaccuracies in your personal information</li>
            <li>Request deletion of your personal information</li>
            <li>Opt out of marketing communications</li>
            <li>Restrict processing of your personal information</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Children’s Privacy</h2>
          <p>
            Our services are not intended for children under the age of 18. We do not knowingly collect personal information from children.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Changes to This Privacy Policy</h2>
          <p>
            We may update this privacy policy from time to time. Any material changes will be communicated by posting the updated policy on our website.
          </p>
        </section>

        <section className="privacy-section contact-info">
          <h2 className="privacy-heading">Contact Us</h2>
          <p>If you have any questions or concerns about this privacy policy, please contact us at:</p>
          <p><strong>Phone:</strong> 
+1 (945)-358-4442</p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:info@easytaxexperts.com">info@easytaxexperts.com</a>
          </p>
        </section>
      </main>

      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Privacypolicy;
